function stripText(element) {
    element.contents().filter(function () {
        return (this.nodeType == 3);
    }).remove();
    return element
}

function changeAddIcon(container, klass = "") {
    let addButton = container.find('.has-many-add');
    addButton.addClass("customized");
    addButton.addClass(klass);
    addButton.html('<i class="fa-solid fa-circle-plus"></i>');
}

function changeRemoveIcon(fieldset) {
    // console.log(fieldset)
    fieldset.find('> ol').css("width", 'calc(100% - 40px)');
    let removeButton = fieldset.find('> ol > li > .has-many-remove');

    removeButton.html('<i class="fa-solid fa-trash"></i>');
    let input = fieldset.find('input:visible:last').not(":checkbox");
    // input.css("width", 'calc(100% - 40px)')
    removeButton.addClass("customized")
    removeButton.insertAfter(input)
}

function changeDeleteInput(fieldset) {
    fieldset.find('> ol').css("width", 'calc(100% - 40px)');
    let removeButton = fieldset.find('> ol > li.boolean.has-many-delete');

    stripText(removeButton.find('label'));
    let input = fieldset.find("input:visible").not(":checkbox");
    // input.css("width", 'calc(100% - 40px)')
    const label = 'Rimuovi al salvataggio';
    removeButton.addClass("customized").attr('title', label);

}

export { changeAddIcon, changeRemoveIcon, changeDeleteInput }